import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import TopBackBtn from '../../components/top_back_btn/top_back_btn';

import { faqList } from '../../data/faq';
import styles from './support_faq_detail.module.css';

const SupportFaqDetail = () => {
  const location = useLocation();
  const { pathname } = location;
  const pathArr = pathname.split('/');
  const id = pathArr[pathArr.length - 1];
  const faq = faqList.find((faq) => faq.faqId === id * 1);
  const { question, answer } = faq || '';

  const navigate = useNavigate();
  const backToList = (e) => {
    e.preventDefault();
    navigate(-1, { state: { from: pathname } });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.contentsContainer}>
        <TopBackBtn text='이전으로' onClick={backToList} />
        <h3 className={styles.question}>{question}</h3>
        <div
          className={styles.answer}
          dangerouslySetInnerHTML={{ __html: answer }}
        />
      </div>
    </div>
  );
};

export default SupportFaqDetail;
